import React, {Component} from 'react';
import Service from "../models/Service";
import {Trans} from "react-i18next";

interface Props {
    service: Service
}

export default class ServiceIconBox extends Component<Props> {
  render() {
    return (
      <div className="col-lg-4 col-md-6">

        {/* service */}
        <div className="art-a art-service-icon-box">
          {/* service content */}
          <div className="art-service-ib-content">
            {/* title */}
            <h5 className="mb-15">{this.props.service.title}</h5>
            {/* text */}
            <div className="mb-15">{this.props.service.description}</div>
            {/* button */}
            <div className="art-buttons-frame">
              <a href="contact.html" className="art-link art-color-link art-w-chevron">
                <Trans style={{ textTransform: 'uppercase'}}>actions.orderNow</Trans>
              </a>
            </div>
          </div>
          {/* service content end */}
        </div>
        {/* service end */}

      </div>
    );
  }
}
